import { QueueBatchItem } from './queue-batch-item.interface';

export interface QueueBatch {
	id?: number;
	queueId: number;
	startDate?: Date | null;
	endDate?: Date | null;
	instanceId?: string | null;
	linkId: number;
	status: QueueBatchStatus;
	queueBatchItems: QueueBatchItem[];
	logId?: string | null;
	sessionId: string;
	batchIndex: number;
}

export enum QueueBatchStatus {
	Unknown = 0,
	Completed = 1,
	Pending = 2,
	InProgress = 3,
	Failed = 4,
}

export class QueueBatchDetailed implements QueueBatch {
	id?: number;
	queueId: number;
	startDate?: Date;
	endDate?: Date;
	instanceId?: string;
	linkId: number;
	status: QueueBatchStatus;
	queueBatchItems: QueueBatchItem[];
	logId?: string;
	sessionId: string;
	batchIndex: number;

	//Additional parameters
	title: string;
}
